module.exports = __webpack_public_path__ + "img/02Pn.7176cd24.jpeg";